<template>
    <div id="page-main-footer" class="bg-secondary p-5" style="width: 100% !important">
        <div class="container" v-if="showContactInfo">
            <h2 class="text-danger display-3 montserrat-bold text-uppercase mb-6">Get in touch</h2>
            <div class="row">
                <div class="col-lg-6">
                    <contact-us-form></contact-us-form>
                </div>
                <div class="col-lg-6">
                    <h3 class="text-body display-4 montserrat-bold text-uppercase mb-3">Contact Us</h3>
                    <div class="row">
                        <div class="col-lg-10 mb-4">
                            <span class="icon-bullet-icon" style=""><div class="fa fa-phone"></div></span>
                            <div class="icon-bullet-text-wrapper">
                                <!-- <div class="icon-bullet-text">{{ cs.landline }} (Landline)</div> -->
                                <div class="icon-bullet-text">{{ cs.smart }}</div>
                            </div>
                        </div>
                        <div class="col-lg-10 mb-4">
                            <span class="icon-bullet-icon" style=""><div class="fa fa-envelope"></div></span>
                            <div class="icon-bullet-text-wrapper">
                                <div class="icon-bullet-text" v-text="cs.email"></div>
                            </div>
                        </div>
                        <div class="col-lg-10 mb-4">
                            <span class="icon-bullet-icon" style=""><div class="fa fa-envelope"></div></span>
                            <div class="icon-bullet-text-wrapper">
                                <div class="icon-bullet-text">{{ cs.address }}</div>
                            </div>
                        </div>
                        <div class="col-lg-10 mt-5">
                            <a :href="links.social.facebook" class="btn btn-outline-primary social-link mr-2">
                                <i class="fab fa-facebook-f"></i>
                            </a>
                            <a :href="links.social.instagram" class="btn btn-outline-primary social-link mr-2">
                                <i class="fab fa-instagram"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer class="py-3 pt-5">
            <div class="container">
                <div class="row align-items-center justify-content-xl-between">
                    <div class="col-xl-6">
                        <div class="copyright text-center text-xl-left text-muted">
                        © 2019 <a :href="links.app" class="font-weight-bold ml-1" target="_blank" v-text="appName"></a>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <ul class="nav nav-footer justify-content-center justify-content-xl-end">
                            <li class="nav-item"><a :href="links.supplyOfServices" class="nav-link">Terms & Conditions</a></li>
                            <li class="nav-item"><a :href="links.privacyPolicy" class="nav-link">Privacy Policy</a></li>
                            <li class="nav-item"><a :href="links.policyStatement" class="nav-link">Policy Statement</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
import { pageRoute } from "@utils/network";
import { default as config } from "@src/config";
import ContactUsForm from "./ContactUsForm";

export default {
    name: "GuestFooter",

    components: { ContactUsForm },

    computed: {
        showContactInfo() {
            return this.$store.getters.isFooterContactsShown
        }
    },

    data: () => ({
        links: {
            social: {
                facebook: config.FACEBOOK_PAGE_LINK,
                instagram: config.INSTAGRAM_PAGE_LINK,
            },
            app: pageRoute(""),
            supplyOfServices: pageRoute("supply-of-services"),
            privacyPolicy: pageRoute("privacy-policy"),
            policyStatement: pageRoute("policy-statement"),
            
        },
        appName: "Cutiefyme",
        cs: {
            address: config.CS_ADDRESS,
            landline: config.CS_LANDLINE,
            smart: config.CS_MOBILE,
            email: config.CS_EMAIL,
        }
    })
}
</script>